import {AfterViewInit, Component, QueryList, ViewChildren} from "@angular/core";
import {BdpkConfigService} from "../../../../bdpk-common/services/bdpk-config.service";
import {DxPageHeaderOptions} from "../../../../dx-page-markup/domain/ui-options/page-header/dx-page-header-options";
import {DxAuthService} from "../../../../dx-auth/services/dx-auth.service";
import {DxCredentialsSubmittedEvent} from "../../../../dx-auth/domain/events/dx-credentials-submitted-event";
import {DxLoginFormComponent} from "../../../../dx-auth/ui/components/login-form/dx-login-form.component";
import {DxOperationResultType} from "../../../../dx-core/domain/common/dx-operation-result-type";
import {PitNavigationService} from "../../../../pit-navigation/services/pit-navigation.service";
import {DxPageOptions} from "../../../../dx-page-markup/domain/ui-options/page/dx-page-options";


@Component({
  selector: 'pit-login-page',
  templateUrl: './pit-login-page.component.html',
  styleUrls: ['./pit-login-page.component.css']
})
export class PitLoginPageComponent implements AfterViewInit {
  private readonly _pageOptions: DxPageOptions;
  private _headerOptions: DxPageHeaderOptions;

  @ViewChildren(DxLoginFormComponent)
  public loginFormQL: QueryList<DxLoginFormComponent> = new QueryList();
  private _loginForm: DxLoginFormComponent;

  constructor(private _configService: BdpkConfigService,
              private _authService: DxAuthService,
              private _navigationService: PitNavigationService) {
    this._pageOptions = new DxPageOptions();
    this._pageOptions.withoutPageSide = true;
  }

  ngOnInit(): void {
    this._headerOptions = this._configService.bdpkLoginPageHeaderOptions;
  }

  ngAfterViewInit(): void {
    this._loginForm = this.loginFormQL.first;
  }

  get pageOptions(): DxPageOptions {
    return this._pageOptions;
  }

  get headerOptions(): DxPageHeaderOptions {
    return this._headerOptions;
  }

  public onSubmitClick(event: DxCredentialsSubmittedEvent): void {
    this._authService.login(event.login, event.password).subscribe(auth => {
      if(DxOperationResultType.SUCCESS == auth.authResult) {
        this._navigationService.redirectToLoginPage();
      } else {
        this._loginForm.isValid = false;
        this._loginForm.loginErrorMsg = auth.error;
      }
    });
  }

  public onRegisterClick(): void {
    alert('Переход на страницу регистрации!');
  }

  public onForgotPasswordClick(): void {
    alert('Переход на страницу восстановления пароля!');
  }
}
